module.exports = __webpack_public_path__ + "assets/070204000275e067afbf3d3a3f3843a1.png";